import Pictogram from '../pictogram';
import React from 'react';
import TranslatedCopy from '../../../intl/translated-copy';
import useWizard from '../wizard/useWizard';
import cx from 'classnames';

const RefundPenaltyChargePaid = ({ }) => {
  const { penaltyChargeCard } = useWizard();
  const cardClasses = cx({
    'RefundPenaltyChargePaid-information-paymentMethod-cardDetails-cardLogo': true,
    'mastercard': penaltyChargeCard.cardType === 'Mastercard',
    'visa': penaltyChargeCard.cardType === 'VisaLogo',
    'amex': penaltyChargeCard.cardType === 'Amex',
  });

  const cardNumber = penaltyChargeCard?.lastDigits;
  const date = `${penaltyChargeCard?.expiryMonth}/${penaltyChargeCard?.expiryYear}`;
  return (
    <div className='RefundPenaltyChargePaid'>
      <div className='RefundPenaltyChargePaid-information'>
        <div className='RefundPenaltyChargePaid-information-paymentMade'>
          <TranslatedCopy
            className='RefundPenaltyChargePaid-information-paymentMade-header'
            copyID='MYB_PAYMENT_MADE'
            tagName='p'
          />
          <div className='RefundPenaltyChargePaid-information-paymentMade-dateWrapper'>
            <Pictogram className='RefundPenaltyChargePaid-information-paymentMade-dateWrapper-calendarIcon' id='CalenderIcon' />
            <p className='RefundPenaltyChargePaid-information-paymentMade-dateWrapper-date'>{ date }</p>
          </div>
        </div>
        <div className='RefundPenaltyChargePaid-information-paymentMethod'>
          <TranslatedCopy
            className='RefundPenaltyChargePaid-information-paymentMethod-method'
            copyID='CC_PAYMENT_METHOD'
            tagName='p'
          />
          <div className='RefundPenaltyChargePaid-information-paymentMethod-cardDetails'>
            <Pictogram id={ penaltyChargeCard?.cardType } className={ cardClasses } />
            <p className='RefundPenaltyChargePaid-information-paymentMethod-cardDetails-cardNumber'>{ `****${cardNumber}` }</p>
          </div>
        </div>
        <div className='RefundPenaltyChargePaid-information-billingAddress'>
          <TranslatedCopy
            className='RefundPenaltyChargePaid-information-billingAddress-title'
            copyID='APP_BILLING_ADDRESS'
            tagName='p'
          />
          <p className='RefundPenaltyChargePaid-information-billingAddress-address'>Cerros de Morelos 25 Edo de México, México 53128 MX</p>
        </div>
      </div>
      <div className='RefundPenaltyChargePaid-pointsReinstallation'>
        <TranslatedCopy
          className='RefundPenaltyChargePaid-pointsReinstallation-reinstallationTitle'
          copyID='MYB_REINSTALLATION_IN_POINTS'
        />
        <div className='RefundPenaltyChargePaid-pointsReinstallation-wrapper'>
          <div className='RefundPenaltyChargePaid-pointsReinstallation-wrapper-section'>
            <TranslatedCopy
              className='RefundPenaltyChargePaid-pointsReinstallation-wrapper-section-reinstallationPtsHeader'
              copyID='MYB_POINTS_REFUNDED'
              tagName='p'
            />
            <div className='RefundPenaltyChargePaid-pointsReinstallation-wrapper-section-amountWrapper'>
              <p className='RefundPenaltyChargePaid-pointsReinstallation-wrapper-section-amountWrapper-amount'>$0</p>
              <TranslatedCopy
                className='RefundPenaltyChargePaid-pointsReinstallation-wrapper-section-amountWrapper-currency'
                copyID='MYB_POINTS_SELECT'
                tagName='p'
              />
            </div>
          </div>
          <div className='RefundPenaltyChargePaid-pointsReinstallation-wrapper-section'>
            <TranslatedCopy
              className='RefundPenaltyChargePaid-pointsReinstallation-wrapper-section-reinstallationPtsHeader'
              copyID='MYB_REINSTALLMENT_CHARGE'
              tagName='p'
            />
            <div className='RefundPenaltyChargePaid-pointsReinstallation-wrapper-section-amountWrapper'>
              <p className='RefundPenaltyChargePaid-pointsReinstallation-wrapper-section-amountWrapper-amount'>$200</p>
              <TranslatedCopy
                className='RefundPenaltyChargePaid-pointsReinstallation-wrapper-section-amountWrapper-currency'
                copyID='MYB_MXN_CURRENCY'
                tagName='p'
              />
            </div>
          </div>
        </div>
        <div className='RefundPenaltyChargePaid-pointsReinstallation-horizontalLine' />
        <div className='RefundPenaltyChargePaid-pointsReinstallation-totalSection'>
          <TranslatedCopy
            className='RefundPenaltyChargePaid-pointsReinstallation-totalSection-header'
            copyID='APP_TOTAL'
            tagName='p'
          />
          <div className='RefundPenaltyChargePaid-pointsReinstallation-totalSection-totalWrapper'>
            <p className='RefundPenaltyChargePaid-pointsReinstallation-totalSection-totalWrapper-total'>$200</p>
            <TranslatedCopy
              className='RefundPenaltyChargePaid-pointsReinstallation-totalSection-totalWrapper-currency'
              copyID='MYB_MXN_CURRENCY'
              tagName='p'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPenaltyChargePaid;
